module.exports = __webpack_public_path__ + "static/pic01-bc5345ab4f7cffe8f55a880c96695687.jpg";